/**
 * LG Band battery percentage.
 *
 * Preferred source: the band's own battery % (payload field 18, firmware >= 1.3.6) when the
 * import stores it as `latest_battery_pct`. Fallback: estimate from rest voltage using a
 * Li-ion discharge curve with the firmware's 3.10 V = 0 % cutoff. Always clamped to 0-100.
 * Returns null when nothing usable is known (never 0, which would read as "flat").
 */
const CURVE = [ // [volts, percent] — typical 1S Li-ion rest-voltage curve, 3.10 V cutoff
  [3.10, 0], [3.30, 3], [3.45, 8], [3.55, 15], [3.65, 25], [3.72, 40],
  [3.80, 55], [3.88, 68], [3.95, 80], [4.05, 90], [4.12, 96], [4.20, 100],
];

export function batteryPercentFromVoltage(volts) {
  const v = Number(volts);
  if (!Number.isFinite(v) || v <= 0) return null;          // 0.00 = "could not read" per firmware doc
  if (v <= CURVE[0][0]) return 0;
  if (v >= CURVE[CURVE.length - 1][0]) return 100;
  for (let i = 1; i < CURVE.length; i++) {
    const [v1, p1] = CURVE[i];
    if (v <= v1) {
      const [v0, p0] = CURVE[i - 1];
      return Math.round(p0 + ((v - v0) / (v1 - v0)) * (p1 - p0));
    }
  }
  return 100;
}

export function lgBandBatteryPercent(data) {
  const reported = Number(data?.latest_battery_pct);
  if (Number.isFinite(reported) && reported >= 0) return Math.max(0, Math.min(100, Math.round(reported)));
  return batteryPercentFromVoltage(data?.latest_voltage);
}
